import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { Field, BTN, EmptyState } from "../Common";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const weekday = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short" });

export const HolidaysTab = () => {
  const [ents, setEnts] = useState([]);
  const [ent, setEnt] = useState("");
  const [year, setYear] = useState(String(new Date().getFullYear()));
  const [list, setList] = useState([]);
  const [f, setF] = useState({ date: "", name: "" });

  useEffect(() => {
    api.get("/entities").then((r) => { setEnts(r.data); setEnt((e) => e || r.data[0]?.id || ""); });
  }, []);
  const load = () => ent && /^\d{4}$/.test(year) && api.get("/holidays", { params: { entity_id: ent, year } }).then((r) => setList(r.data));
  useEffect(() => {
    load();
  }, [ent, year]); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/holidays", { ...f, entity_id: ent });
      toast.success("Holiday added");
      setF({ date: "", name: "" });
      load();
    } catch (err) { toast.error(formatErr(err)); }
  };
  const del = async (h) => {
    try { await api.delete(`/holidays/${h.id}`); toast.success("Holiday removed"); load(); } catch (err) { toast.error(formatErr(err)); }
  };

  return (
    <div data-testid="holidays-tab">
      <p className="text-sm text-[#6E6E73] mb-4">Holidays are set per company. They are not counted in leave days or unpaid-leave deductions, and show as Holiday in the attendance roster.</p>
      <div className="flex flex-wrap gap-3 mb-4">
        <Select value={ent || undefined} onValueChange={setEnt}>
          <SelectTrigger className="w-64 bg-white" data-testid="holiday-entity-select"><SelectValue placeholder="Select entity" /></SelectTrigger>
          <SelectContent>{ents.map((x) => <SelectItem key={x.id} value={x.id}>{x.name}</SelectItem>)}</SelectContent>
        </Select>
        <Input type="number" className="w-28 bg-white" value={year} onChange={(e) => setYear(e.target.value)} data-testid="holiday-year-input" />
      </div>
      <form onSubmit={add} className="bg-white border border-[#E5E5EA] rounded-2xl p-4 flex flex-col sm:flex-row gap-3 sm:items-end mb-4" data-testid="holiday-form">
        <Field label="Date"><Input type="date" required value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="holiday-date-input" /></Field>
        <Field label="Holiday name" className="flex-1"><Input required placeholder="e.g. Diwali" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="holiday-name-input" /></Field>
        <Button type="submit" disabled={!ent} className={BTN} data-testid="add-holiday-button"><Plus className="h-4 w-4 mr-1" />Add holiday</Button>
      </form>
      {!list.length ? <EmptyState text={`No holidays added for ${year}`} testid="holidays-empty" /> : (
        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#F0F0F2]" data-testid="holidays-list">
          {list.map((h) => (
            <div key={h.id} className="flex items-center justify-between px-4 py-3" data-testid={`holiday-row-${h.date}`}>
              <div className="flex items-center gap-4">
                <div className="w-14 text-center rounded-lg bg-[#F7EEE2] py-1">
                  <div className="text-[10px] uppercase font-bold text-[#C87515]">{weekday(h.date)}</div>
                  <div className="text-lg font-extrabold leading-tight">{h.date.slice(8)}</div>
                </div>
                <div><div className="font-semibold">{h.name}</div><div className="text-xs text-[#6E6E73]">{fmtDate(h.date)}</div></div>
              </div>
              <Button size="icon" variant="ghost" className="text-red-600" onClick={() => del(h)} data-testid={`delete-holiday-${h.date}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
